import React from 'react'
import cx from 'classnames'
import { withUniqueId } from '../../utils/withUniqueId'
import { MapStatic } from './Map.static'
import { clientOnly } from '../../utils/hoc'

const CLASS_ROOT = 'map'

interface MapProps {
  id?: string
  uniqueId: () => any
  /** Options for the map https://developers.google.com/maps/documentation/javascript/reference/3.exp/map */
  mapOptions?: object
  /** Array of locations */
  locations: object[]
  className?: string
}

class MapInner extends React.Component<MapProps> {
  map: MapStatic | null = null

  async componentDidMount() {
    const gmaps = (await import('google-maps')).default
    const { id, mapOptions = {}, locations } = this.props

    this.map = new MapStatic(gmaps, id!, locations, mapOptions)
  }

  render() {
    const { className, id } = this.props
    const classes = cx(CLASS_ROOT, className)

    return <div id={id} className={classes} />
  }
}

export const Map = clientOnly(withUniqueId()(MapInner))
